import { render, staticRenderFns } from "./BatchSelectActions.vue?vue&type=template&id=65c90ad3&"
import script from "./BatchSelectActions.vue?vue&type=script&lang=js&"
export * from "./BatchSelectActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65c90ad3')) {
      api.createRecord('65c90ad3', component.options)
    } else {
      api.reload('65c90ad3', component.options)
    }
    module.hot.accept("./BatchSelectActions.vue?vue&type=template&id=65c90ad3&", function () {
      api.rerender('65c90ad3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/viewKnowledge/documents/components/BatchSelectActions.vue"
export default component.exports